// extracted by mini-css-extract-plugin
export default {"options":"RadioAnswer_options__Yut9d","selected":"RadioAnswer_selected__4xxei"};